import notify from "devextreme/ui/notify";

import type { Result } from "starfx";

function isResultWithValue<T>(
  result: Result<T>
): result is { ok: true; value: T } {
  return "value" in result;
}

export function callValue<T>(
  result: Result<T>,
  customErrorMessage?: string,
  output?: "notify" | "console" | "terminal"
): T {
  if (!isResultWithValue(result)) {
    const outMsg =
      customErrorMessage ||
      (
        result as {
          readonly ok: false;
          error: Error;
        }
      ).error.message;

    switch (output) {
      case "notify":
        {
          notify(
            {
              message: outMsg,
              width: 400,
              position: {
                at: "top",
                my: "top",
                of: "#root",
                offset: "0 22",
              },
            },
            "error",
            3000
          );
        }
        break;
      case "console":
        {
          console.log(outMsg);
          console.log(result);
        }
        break;
      case "terminal":
        {
          console.log(outMsg);
          console.log(result);
        }
        break;
    }
    throw (
      result as {
        readonly ok: false;
        error: Error;
      }
    ).error;
  }
  return result.value;
}
